<template>
  <div class="torchlight-heroes" :class="[`in-${screen}`, { 'font-cn': lang == 'cn' }]">
    <component
      v-if="thisComponent"
      v-bind:is="thisComponent"
      :heroes="heroes"
      :subHeroName="subHeroName"
      :subHeroID="subHeroID"
      :subLocale="subLocale"
      :appOnly="appOnly"
      :lang="lang"
      @switch-hero="switchHero"
      @init-transitions-end="initTransitionsEnd"
    ></component>
  </div>
</template>

<script>
import { debounce } from "lodash";
import _lg from "./libs/lg";
import locales from "./libs/locales";

import Vue from "vue";
import VueLazyload from "vue-lazyload";
Vue &&
  Vue.use(VueLazyload, {
    // preLoad: 1.3,
    attempt: 2,
    // listenEvents: ["scroll"],
  });

export default {
  name: "SectionRoles",
  components: {
    BlockPc: () => import("./roles/roles-pc"),
    BlockApp: () => import("./roles/roles-app"),
  },
  props: {
    lang: {
      type: String,
      default: () => "en",
    },
    mediaScreen: {
      type: Number,
      default: () => 828
    },
    appOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      screen: "",
      videoList: [],
      subHeroName: "thea",
      subHeroID: "thea_3",
      transitions: {},
      data_size_listen: {},
      heroes: [
        {
          name: "selena",
          subHeroID: "selena_1",
          specialty: [
            {
              id: "selena_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/poster/172664/homepage/GaM3xfnD.png",
              lie_bg:
                "https://website.xdcdn.net/poster/172664/homepage/GaKYjv0P.png",
              spine: {
                appendEleID: "selenaSpine",
                size: {
                  width: 3447,
                  height: 2445,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/sailinna/sailinna.json",
                position: {
                  x: 2120,
                  y: 3100,
                },
                scale: 0.8,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/poster/227017/homepage/Gbvc6TLE.png",
              skill: "selena_skill_1",
              intro: "selena_introduction_1",
              video: "https://website.xdcdn.net/poster/227017/homepage/GbOPu6gh.mp4",
              video_poster: "https://website.xdcdn.net/poster/172664/homepage/GaKfKCzB.png"
            },
          ],
        },
        {
          name: "rosa",
          subHeroID: "rosa_1",
          specialty: [
            {
              id: "rosa_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/poster/172664/homepage/BDo3Gwqq.png",
              lie_bg:
                "https://website.xdcdn.net/poster/172664/homepage/BEtxUFQ9.png",
              spine: {
                appendEleID: "rosaSpine",
                size: {
                  width: 1845,
                  height: 1511,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Rosa/Rosa.json",
                position: {
                  x: 1020,
                  y: 1350,
                },
                scale: 0.65,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/poster/172664/homepage/BDofHrZp.png",
              skill: "rosa_skill_1",
              intro: "rosa_introduction_1",
              video: "https://website.xdcdn.net/poster/172664/homepage/BDolb5hg.mp4",
              video_poster: "https://website.xdcdn.net/poster/172664/homepage/BDomBCmy.jpg"
            },
          ],
        },
       {
          name: "iris",
          subHeroID: "iris_1",
          specialty: [
            {
              id: "iris_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/poster/172664/homepage/APrL5Zvq.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie_bg.png",
              spine: {
                appendEleID: "irisSpine",
                size: {
                  width: 1400,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/yiruisi/yuansushi.json",
                position: {
                  x: 650,
                  y: 1100,
                },
                scale: 0.8,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/poster/172664/homepage/APhcrtJt.png",
              skill: "iris_skill_1",
              intro: "iris_introduction_1",
              video: "https://website.xdcdn.net/poster/172664/ss2/stage2/p/section3/9L9K4w1e.mp4",
              video_poster: "https://website.xdcdn.net/poster/172664/homepage/APickUZo.png"
            },
            {
              id: "iris_2",
              lie: "https://website.xdcdn.net/poster/227017/homepage/ss7/HsNdDHRu.png",
              lie_app: "https://website.xdcdn.net/poster/227017/homepage/ss7/HsQXFpig.png",
              lie_bg:
                "https://website.xdcdn.net/poster/227017/homepage/ss7/HrME68og.png",
              icon: "https://website.xdcdn.net/poster/227017/homepage/ss7/HsNpVJL2.png",
              skill: "iris_skill_2",
              intro: "iris_introduction_2",
              video: "https://website.xdcdn.net/poster/227017/homepage/ss7/HsOa1CF5.mp4",
              video_poster: "https://website.xdcdn.net/poster/227017/homepage/ss7/HsOV8bHk.jpg"
            },
          ],
        },
        {
          name: "erika",
          subHeroID: "erika_2",
          specialty: [
            {
              id: "erika_2",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/erika_2.png",
              lie_bg: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie_bg.png",
              spine: {
                appendEleID: "erika2Spine",
                size: {
                  width: 1400,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Erika/Cat.json",
                position: {
                  x: 770,
                  y: 610,
                },
                scale: 0.55,
                animation: "IdleAnim_Loop",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/erika/skill/2.png",
              skill: "erika_skill_2",
              intro: "erika_introduction_2",
              video: "https://poster.xdcdn.net/xd-website/homepage/torchlight/videos/erika_skill_2.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/erika_2.jpg"
            },
            {
              id: "erika_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/erika_1.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/erika_1.png",
              spine: {
                appendEleID: "erikaSpine",
                size: {
                  width: 1400,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Erika/maoyan11.json",
                position: {
                  x: 700,
                  y: 970,
                },
                scale: 1,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/erika/skill/1.png",
              skill: "erika_skill_1",
              intro: "erika_introduction_1",
              video: "https://website.xdcdn.net/poster/227017/epicycle/ep-2/hero_erika.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/erika_1.png"
            }
          ],
        },
        {
          name: "thea",
          subHeroID: "thea_3",
          specialty: [
            {
              id: "thea_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/thea_1.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/thea_1.png",
              spine: {
                appendEleID: "theaSpine",
                size: {
                  width: 1680,
                  height: 1164,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Thea/shenyuzhe1.json",
                position: {
                  x: 700,
                  y: 1450,
                },
                scale: 0.88,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/thea/skill/1.png",
              skill: "thea_skill_1",
              intro: "thea_introduction_1",
              video: "https://video-pt.xdcdn.net/video/2022/10/12/f392cb75887c1b2b7a10244dd6756645/3f1767b79c6f4f01-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/thea_1.png"
            },
            {
              id: "thea_2",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/thea_2.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/thea_2.png",
              spine: {
                appendEleID: "thea2Spine",
                size: {
                  width: 1680,
                  height: 1164,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Thea_Section2/yuenv.json",
                position: {
                  x: 900,
                  y: 1300,
                },
                scale: 0.95,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/hero/thea/skill_2.png",
              skill: "thea_skill_2",
              intro: "thea_introduction_2",
              video: "https://poster.xdcdn.net/xd-website/homepage/torchlight/videos/thea_skill_2.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/thea_2.png"
            },
            {
              id: "thea_3",
              lie: "https://website.xdcdn.net/poster/227017/homepage/ss8/JOyhNs0s.png",
              lie_app: "https://website.xdcdn.net/poster/227017/homepage/ss8/JPtWj1PG.png",
              lie_bg:
                "https://website.xdcdn.net/poster/227017/homepage/ss8/JOyhNRXk.png",
              icon: "https://website.xdcdn.net/poster/227017/homepage/ss8/JOzm2sBI.png",
              skill: "thea_skill_3",
              intro: "thea_introduction_3",
              video: "https://website.xdcdn.net/homepage/torchlight/video/ss8_hero_thea.mp4",
              video_poster: "https://website.xdcdn.net/poster/227017/homepage/ss8/JPt0zZFy.jpg"
            },
          ],
        },
        {
          name: "moto",
          subHeroID: "moto_1",
          specialty: [
            {
              id: "moto_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/moto_1.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/moto_1.png",
              spine: {
                appendEleID: "motoSpine",
                size: {
                  width: 1400,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Moto/airen.json",
                position: {
                  x: 660,
                  y: 960,
                },
                scale: 0.8,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/moto/skill/1.png",
              skill: "moto_skill_1",
              intro: "moto_introduction_1",
              video: "https://video-pt.xdcdn.net/video/2022/04/12/62569070e15aec95bc6d5dd95c6845a9/fb4b29f4f6e346e8-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/moto_1.png"
            },
            {
              id: "moto_2",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/moto_2.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/moto_2.png",
              spine: {
                appendEleID: "moto2Spine",
                size: {
                  width: 1400,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Moto/Moto02.json",
                position: {
                  x: 650,
                  y: 1060,
                },
                scale: 1.1,
                animation: "IdleAnim_Loop",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/pc/hero/skill_moto_2.png",
              skill: "moto_skill_2",
              intro: "moto_introduction_2",
              video: "https://website.xdcdn.net/poster/227017/epicycle/ep-2/hero_moto.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/moto_2.png"
            },
          ],
        },
        {
          name: "carino",
          subHeroID: "carino_3",
          specialty: [
            {
              id: "carino_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/carino_1.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/carino_1.png",
              spine: {
                appendEleID: "carinoSpine",
                size: {
                  width: 1600,
                  height: 970,
                },
                jsonUrl:
                  "https://poster.xdcdn.net/xd-website/homepage/torchlight/imgs/spine/Carino/Carino.json",
                position: {
                  x: 1080,
                  y: 1020,
                },
                scale: 0.65,
                animation: "CarinoAnim_alone",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/carino/skill/2.png",
              skill: "carino_skill_1",
              intro: "carino_introduction_1",
              video: "https://video-pt.xdcdn.net/video/2021/12/14/0566781c0863dd26f43e67202d096f23/8dd70929356a4a86-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/carino_1.png"
            },
            {
              id: "carino_2",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/carino_2.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/carino_2.png",
              spine: {
                appendEleID: "carino2Spine",
                size: {
                  width: 1600,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Carino/UI_Spine_Carino03.json",
                position: {
                  x: 520,
                  y: 1000,
                },
                scale: 0.92,
                animation: "IdleAnim_Loop",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/carino/skill/1.png",
              skill: "carino_skill_2",
              intro: "carino_introduction_2",
              video: "https://video-pt.xdcdn.net/video/2022/10/12/4a3b92d6f91eb5c3eac8ecfaa39c7bee/c28579b2bae854e6-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/carino_2.png"
            },
            {
              id: "carino_3",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/carino_3.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/carino_2.png",
              spine: {
                appendEleID: "carino3Spine",
                size: {
                  width: 1426,
                  height: 1016,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Carino_Divineshot/1.json",
                position: {
                  x: 820,
                  y: 1200,
                },
                scale: 0.3,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/carino/skill/3.png",
              skill: "carino_skill_3",
              intro: "carino_introduction_3",
              video: "http://poster.xdcdn.net/xd-website/homepage/torchlight/videos/ss5_divineshot_en.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/carino_3.png"
            }
          ],
        },
        {
          name: "rehan",
          subHeroID: "rehan_1",
          specialty: [
            {
              id: "rehan_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/rehan_1.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/rehan_1.png",
              spine: {
                appendEleID: "rehanSpine",
                size: {
                  width: 1300,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Rehan/skeleton.json",
                position: {
                  x: 540,
                  y: 1050,
                },
                scale: 0.75,
                animation: "RehanAnim_alone",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/rehan/skill/1.png",
              skill: "rehan_skill_1",
              intro: "rehan_introduction_1",
              video: "https://video-pt.xdcdn.net/video/2021/12/14/786004cfb5a6064c4decb92edc548e07/106e68c9e2036e88-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/rehan_1.png"
            },
            {
              id: "rehan_2",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/rehan_2.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/rehan_2.png",
                spine: {
                appendEleID: "rehan2Spine",
                size: {
                  width: 1300,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Rehan/Rehan02.json",
                position: {
                  x: 810,
                  y: 1030,
                },
                scale: 0.88,
                animation: "IdleAnim_Loop",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/rehan/skill/2.png",
              skill: "rehan_skill_2",
              intro: "rehan_introduction_2",
              video: "https://website.xdcdn.net/poster/227017/epicycle/ep-2/hero_rehan.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/rehan_2.png"
            },
          ],
        },
        {
          name: "gemma",
          subHeroID: "gemma_4",
          specialty: [
            {
              id: "gemma_4",
              lie: "",
              lie_app: "https://website.xdcdn.net/poster/172664/homepage/APrd0fCi.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie_bg.png",
                spine: {
                appendEleID: "gemma4Spine",
                size: {
                  width: 1653,
                  height: 1257,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/jima/Gemma03.json",
                position: {
                  x: 850,
                  y: 1547,
                },
                scale: 0.9,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/poster/172664/homepage/APhcrCfG.png",
              skill: "gemma_skill_4",
              intro: "gemma_introduction_4",
              video: "https://website.xdcdn.net/poster/172664/ss2/stage2/p/section3/9L9K8irD.mp4",
              video_poster: "https://website.xdcdn.net/poster/172664/homepage/APickUZo.png"
            },
            {
              id: "gemma_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/gemma_1.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/gemma_1.png",
              spine: {
                appendEleID: "gemmaSpine",
                size: {
                  width: 1400,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Gemma/skeleton.json",
                position: {
                  x: 850,
                  y: 1100,
                },
                scale: 0.75,
                animation: "GemmaAnim_alone",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/gemma/skill/3.png",
              skill: "gemma_skill_1",
              intro: "gemma_introduction_1",
              video: "https://video-pt.xdcdn.net/video/2021/06/17/08b9a1abdc64026a360707c1ef513dc0/2120466751dd0058-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/gemma_1.png"
            },
            {
              id: "gemma_2",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/gemma_2.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/gemma_2.png",
                spine: {
                appendEleID: "gemma2Spine",
                size: {
                  width: 1400,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Gemma/Gemma03.json",
                position: {
                  x: 570,
                  y: 1100,
                },
                scale: 1,
                animation: "IdleAnim_Loop",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/gemma/skill/2.png",
              skill: "gemma_skill_2",
              intro: "gemma_introduction_2",
              video: "https://video-pt.xdcdn.net/video/2022/10/12/5fcb8b159f0b33ade63c757ba2c23325/684130dfdfb5b5b2-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/gemma_2.png"
            },
            
          ],
        },
        {
          name: "youga",
          subHeroID: "youga_1",
          specialty: [
            {
              id: "youga_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/youga_1.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/youga_1.png",
              spine: {
                appendEleID: "yougaSpine",
                size: {
                  width: 1400,
                  height: 970,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Youga/youjia.json",
                position: {
                  x: 600,
                  y: 1030,
                },
                scale: 1,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/youga/skill/1.png",
              skill: "youga_skill_1",
              intro: "youga_introduction_1",
              video: "https://video-pt.xdcdn.net/video/2022/04/12/6788cd46d46cafe801d71ddacd0486db/f6899ac026d5a4e6-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/youga_1.png"
            },
            {
              id: "youga_2",
              lie: "https://website.xdcdn.net/homepage/torchlight/imgs/pc/hero/role_youga_2.png",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/youga_2.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/youga_2.png",
              spine: "",
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/overseas/pc/section5/youga/skill/3.png",
              skill: "youga_skill_2",
              intro: "youga_introduction_2",
              video: "https://video-pt.xdcdn.net/video/2022/10/12/1c2b28e8bf59b2b9666cf47644d88eac/b6e3040cc7db4edd-1080p.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/youga_2.png"
            },
          ],
        },
        {
          name: "bing",
          subHeroID: "bing_1",
          specialty: [
            {
              id: "bing_1",
              lie: "",
              lie_app: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie/bing_1.png",
              lie_bg:
                "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/lie_bg/bing_1.png",
              spine: {
                appendEleID: "bingSpine",
                size: {
                  width: 1400 * 1.2,
                  height: 970 * 1.2,
                },
                jsonUrl:
                  "https://website.xdcdn.net/homepage/torchlight/imgs/spine/Bing_Section2/zhadanren.json",
                position: {
                  x: 860,
                  y: 1350,
                },
                scale: 0.55,
                animation: "idle",
              },
              icon: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/hero/bing/skill_1.png",
              skill: "bing_skill_1",
              intro: "bing_introduction_1",
              video: "https://poster.xdcdn.net/xd-website/homepage/torchlight/videos/bing_skill_1.mp4",
              video_poster: "https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/poster/bing_1.png"
            },
          ],
        },
      ],
      inViewed: false,
      showElementDelay: false,
      thisComponent: "",
      lg: _lg,
      subLocale: {},
    };
  },
  watch: {
    data_size_listen: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (this.appOnly) {
            this.screen = "app";
            this.thisComponent = "BlockApp";
            return;
          }
          if (this.lg(newVal, "screenWidth", 0) > this.mediaScreen) {
            this.screen = "pc";
            this.thisComponent = "BlockPc";
          } else {
            this.screen = "app";
            this.thisComponent = "BlockApp";
          }
        }
      },
      immediate: true,
      deep: true,
    },
    lang: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.subLocale = locales[newVal] || locales.en;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.appOnly) {
      this.screen = "app";
      this.thisComponent = "BlockApp";
    }
    window.onresize = this.handleResize;
    this.handleResize();
  },
  methods: {
    switchHero(obj) {
      this.subHeroName = obj.name;
      let subHero = this.heroes.find((item) => item.name == this.subHeroName);
      if (obj.id) {
        this.subHeroID = obj.id;
      } else {
        this.subHeroID = this.lg(subHero, "specialty")[0]["id"];
      }
      subHero["subHeroID"] = this.subHeroID;
      this.transitions[obj.name] && this.transitions[obj.name].restart();
    },
    initTransitionsEnd(transitions) {
      this.transitions = transitions;
    },
    handleResize: debounce(function () {
      this.data_size_listen = {
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
      };
    }, 100),
  },
};
</script>

<style lang="scss" scoped>
@import "./scss/mixin.scss";
.in-pc {
  height: vwPc(1271px, $ratio: 1);
}
.in-app {
  height: vwApp(1808px);
}

@font-face {
  font-family: "YouSheBiaoTiHei";
  src: url("https://xd-website.oss-cn-beijing.aliyuncs.com/homepage/torchlight/imgs/v2.0/font/YouSheBiaoTiHei.eot");
  src: url("https://xd-website.oss-cn-beijing.aliyuncs.com/homepage/torchlight/imgs/v2.0/font/YouSheBiaoTiHei.eot?#iefix") format("embedded-opentype"),
        url("https://xd-website.oss-cn-beijing.aliyuncs.com/homepage/torchlight/imgs/v2.0/font/YouSheBiaoTiHei.woff") format("woff"),
        url("https://xd-website.oss-cn-beijing.aliyuncs.com/homepage/torchlight/imgs/v2.0/font/YouSheBiaoTiHei.ttf") format("truetype"),
        url("https://xd-website.oss-cn-beijing.aliyuncs.com/homepage/torchlight/imgs/v2.0/font/YouSheBiaoTiHei.svg#ChenLiang") format("svg");
  font-style: normal;
  font-weight: normal;
}

.font-cn {
  &.in-pc {
    :deep(.name-box) {
      .name {
        font-family: 'YouSheBiaoTiHei';
        transform: none !important;
        font-weight: normal !important;
      }
    }
  }

  &.in-app {
    :deep(.name-box) {
      .name, .name-nick {
        font-family: 'YouSheBiaoTiHei';
        transform: none !important;
        font-weight: normal !important;
      }
      .name-abb {
        display: block !important;
      }
      .name {
        font-size: vwApp(180px) !important;
        line-height: 0.9 !important;
      }
      .name-nick {
        font-size: vwApp(86px) !important;
        line-height: 0.8 !important;
      }
    }
  }
}
</style>
